module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"new":"Neu","ourSpots":"Unsere Spots"},"en":{"categories":"Categories","ourSpots":"Our Spots"}}')
  delete Component.options._Ctor
}
